module.exports = __webpack_public_path__ + "static/media/partnership_1.7dd6c9a5.png";